import uniqueId from 'lodash/uniqueId';
import React from 'react';

import { UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';
import { ROW_CHILD_COMPONENT_TYPE } from 'app/constants/browse/rows';
import { mapCategoriesToNavRowLinks } from 'app/helpers/browse';
import { immutableUiCategoryByPathShape, uiCategoryShape } from 'app/shapes/browse';
import displayBibShape from 'app/shapes/displayBib';
import PropTypes from 'prop-types';
import Rows from '../shared/Rows';

const BrowseCategoryNodePageContainer = ({ bibsByCategoryPath, category, categoryByPath }) => {
  const { subCategoryPaths } = category;

  // TODO: confirm screen-reader title
  const screenReaderNavTitle = `Browse ${category.title} by category`;

  const navRowLinks = mapCategoriesToNavRowLinks(
    subCategoryPaths.map(nextCategoryPath => categoryByPath.get(nextCategoryPath)?.toJS()).filter(Boolean)
  );

  const displayBibRows = subCategoryPaths.map((nextCategoryPath, index) => {
    const nextCategory = categoryByPath.get(nextCategoryPath)?.toJS() ?? {};
    const { title = '' } = nextCategory;
    const titleUrl = `/v2/browse${nextCategoryPath}`;
    const rowPosition = index + 2;

    return {
      hasAlternativeStyle: false,
      childComponent: {
        mappedProps: {
          displayBibs: bibsByCategoryPath[nextCategoryPath] ?? [],
          hasHistoryRoutingForTitles: true,
          rowPosition,
          title,
          titleUrl
        },
        type: ROW_CHILD_COMPONENT_TYPE.BIBS
      },
      rowId: uniqueId(`${ROW_CHILD_COMPONENT_TYPE.BIBS}_`),
      uiContainerType: UI_CONTAINER_TYPE.BROWSE_ROW_BIB
    };
  });

  const rows = [
    {
      hasAlternativeStyle: false,
      childComponent: {
        mappedProps: {
          links: navRowLinks,
          title: screenReaderNavTitle
        },
        type: ROW_CHILD_COMPONENT_TYPE.NAV
      },
      rowId: uniqueId(`${ROW_CHILD_COMPONENT_TYPE.NAV}_`),
      uiContainerType: UI_CONTAINER_TYPE.BROWSE_ROW_NAV
    }
  ].concat(displayBibRows);

  return <Rows displayAvailabilitByMetadataId={{}} rows={rows} />;
};

BrowseCategoryNodePageContainer.propTypes = {
  bibsByCategoryPath: PropTypes.objectOf(PropTypes.arrayOf(displayBibShape)).isRequired,
  category: uiCategoryShape.isRequired,
  categoryByPath: immutableUiCategoryByPathShape.isRequired
};

export default BrowseCategoryNodePageContainer;
